/* __next_internal_client_entry_do_not_use__ Modal auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { requestIdleCallbackOrFallback } from "@faire/retailer-visitor-shared/lib/requestIdleCallbackOrFallback";
import { useAppModal } from "@faire/retailer-visitor-shared/stores/ui/AppModalStore";
import { usePromoModalToDisplay } from "@faire/retailer-visitor-shared/stores/ui/PromoModalStore";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import React, { Suspense, useMemo, useEffect } from "react";
import { LazyAppModals } from "@faire/retailer/components/App/AppModals";
import { LazyPromoModals } from "@faire/retailer/components/App/PromoModals";
import preloadAppModals from "@faire/retailer/lib/lazyPreload_DO_NOT_RENAME/appModals";
import { useAssignSettingPreloadLoggedOutAppModal, useSettingPreloadLoggedOutAppModal } from "@faire/retailer/settings/useSettingPreloadLoggedOutAppModal";
export var Modal = function(param) {
    var preloadAppModal = param.preloadAppModal;
    var isSSR = useIsSSR();
    var _useAppModal = useAppModal(), canShowAppModal = _useAppModal.isModalShowing;
    var _usePromoModalToDisplay = usePromoModalToDisplay(), canShowPromoModal = _usePromoModalToDisplay.modalToDisplay;
    var modalType = null;
    if (canShowAppModal) {
        modalType = "app";
    // TODO(jocelyn): whether a modal is rendered depends on Storage.local,
    // which can cause a hydration mismatch (FD-127421).
    //
    // Once this is fixed, remove this exception.
    } else if (!isSSR && canShowPromoModal) {
        modalType = "promo";
    }
    var assignPreloadLoggedOutAppModal = useAssignSettingPreloadLoggedOutAppModal();
    var preloadLoggedOutAppModal = useSettingPreloadLoggedOutAppModal();
    useEffect(function() {
        if (preloadAppModal) {
            requestIdleCallbackOrFallback(function() {
                assignPreloadLoggedOutAppModal();
                if (preloadLoggedOutAppModal) {
                    preloadAppModals();
                }
            });
        }
    }, [
        assignPreloadLoggedOutAppModal,
        preloadLoggedOutAppModal,
        preloadAppModal
    ]);
    // We only want to rerender the modal when the modal type changes. This can
    // help avoid SSR misses for the modal caused by internal modal state
    // changes that trigger this component to be re-rendered but do not affect
    // the render output.
    return useMemo(function() {
        if (modalType === "app") {
            return /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyAppModals, {})
            });
        } else if (modalType === "promo") {
            return /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyPromoModals, {})
            });
        }
        return null;
    }, [
        modalType
    ]);
};
